
































































































































































































































































































































































































































































































































































































































import { PropType } from 'vue'
import { Component, Watch, Mixins, Prop } from 'vue-property-decorator'

Component.registerHooks(['validations', 'beforeRouteLeave'])

import {
  mdiLockQuestion,
  mdiKey,
  mdiCalendarAccountOutline,
  mdiCreditCard,
  mdiHome,
  mdiHomeAccount,
  mdiCity,
  mdiPhone,
  mdiEmail,
  mdiInformationOutline,
} from '@mdi/js'

import { mask } from 'vue-the-mask'

import { Route, NavigationGuardNext } from 'vue-router'

import type { BreadcrumbsItem } from '@/components/lib/Breadcrumbs/types'

import type { CaptchaCheck, CardInfo, SelectItem, NspkProgramResidentObject } from '@/api'

import { ClaimsService, NspkService } from '@/api'

import { Alert } from '@/mixins/Alert'

import { claim } from '@/store/modules/claim'
import { dadata } from '@/store/modules/dadata'
import { security } from '@/store/modules/security'
import { ClaimForm } from '@/models'
import { Debounce } from '@/tools/debounce'
import { mock, wait } from '@/tools'

import Breadcrumbs from '@/components/lib/Breadcrumbs/Breadcrumbs.vue'
import LabelRequired from '@/components/lib/LabelRequired.vue'
import CaptchaDialog from '@/components/lib/CaptchaDialog.vue'
import NSPKLoyaltyRegisterFrameManager from '@/components/layouts/NSPKLoyaltyRegisterFrameManager.vue'
import { ConnectCardValidations } from '@/mixins/forms/ConnectCardValidations'
import { DisabledInput } from '@/components/lib/mixins/DisabledInput'

@Component<ConnectCardFormView>({
  directives: { mask },
  components: {
    CaptchaDialog,
    LabelRequired,
    Breadcrumbs,
    NSPKLoyaltyRegisterFrameManager,
  },
})
class ConnectCardFormView extends Mixins<Alert, ConnectCardValidations, DisabledInput>(
  Alert,
  ConnectCardValidations,
  DisabledInput
) {
  claimModule = claim.context(this.$store)
  dadataModule = dadata.context(this.$store)
  securityModule = security.context(this.$store)

  @Prop({
    type: Object as PropType<CardInfo>,
  })
  readonly card!: CardInfo

  breadcrumbsItems: Array<BreadcrumbsItem> = [
    {
      text: 'Главная',
      disabled: false,
      to: { name: 'main' },
    },
    {
      text: this.$route.meta.title,
      disabled: true,
    },
  ]

  form = new ClaimForm(this.securityModule.state.user, this.card)

  step = 1

  isShowCaptcha = false
  captchaAnswers: CaptchaCheck = null

  icons = {
    mdiLockQuestion,
    mdiKey,
    mdiCalendarAccountOutline,
    mdiCreditCard,
    mdiHome,
    mdiHomeAccount,
    mdiCity,
    mdiPhone,
    mdiEmail,
    mdiInformationOutline,
  }
  birthDatePicker = false
  issueDatePicker = false
  nspkProgramResident: NspkProgramResidentObject = null
  searchFactAddress = ''
  searchTemporaryRegAddress = ''
  temporaryRegAddressesList: Array<string> = this.form.contacts.temporaryRegAddress
    ? [this.form.contacts.temporaryRegAddress]
    : []
  factAddressesList: Array<string> = this.form.contacts.factAddress ? [this.form.contacts.factAddress] : []
  searchRegAddress = ''
  regAddressesList: Array<string> = this.form.contacts.regAddress ? [this.form.contacts.regAddress] : []
  issuedByList: Array<string> = this.form.document.issuedBy ? [this.form.document.issuedBy] : []
  isExitTo: Route = null
  isExitAccept = false
  docsType: Array<SelectItem> = []
  gender = [
    { id: 0, name: 'Женский' },
    { id: 1, name: 'Мужской' },
  ]

  agreement = false

  get issueDate() {
    return this.form?.document.issueDate ? new Date(this.form.document.issueDate).toLocaleDateString('Ru-ru') : ''
  }

  get birthDate() {
    return this.form?.mainData.birthDate ? new Date(this.form.mainData.birthDate).toLocaleDateString('Ru-ru') : ''
  }

  get isPassport() {
    return this.form.docType === '1'
  }

  async created() {
    try {
      const [{ list: docsType }, nspkProgramResident] = await Promise.all([
        await ClaimsService.getVisibleDocsType(),
        await NspkService.getProgramResidentId(),
      ])

      this.docsType = docsType
      this.nspkProgramResident = nspkProgramResident
    } catch (error) {
      mock(error)
    }
  }

  mounted() {
    window.onbeforeunload = function () {
      return 'Внесенные данные будут утеряны'
    }
  }

  beforeDestroy() {
    window.onbeforeunload = undefined
  }

  async beforeRouteLeave(to: Route, _from: Route, next: NavigationGuardNext) {
    this.isExitTo = to
    if (this.isExitAccept) next()
    else await this.$vuetify.goTo('#confirm-dialog', { easing: 'easeInOutCubic', duration: 600, offset: 0 })
  }

  @Watch('form', { deep: true })
  @Debounce(500)
  saveFrom(form: ClaimForm) {
    this.claimModule.mutations.setForm(form)
  }

  @Watch('isPassport')
  clearIssueCode(value: boolean) {
    if (value === false) this.form.document.issueCode = null
    this.form.document.issuedBy = null
  }

  @Watch('searchFactAddress')
  @Debounce(500)
  async setFactAddressList(value: string) {
    this.factAddressesList = await this.dadataModule.actions.getAddresses(value).catch(mock)
  }

  @Watch('searchRegAddress')
  @Debounce(500)
  async setRegAddressList(value: string) {
    this.regAddressesList = await this.dadataModule.actions.getAddresses(value).catch(mock)
  }

  @Watch('searchTemporaryRegAddress')
  @Debounce(500)
  async setTemporaryRegAddressList(value: string) {
    this.temporaryRegAddressesList = await this.dadataModule.actions.getAddresses(value).catch(mock)
  }

  @Watch('form.document.issueCode')
  @Debounce(500)
  async setIssuedByList(code: string) {
    if (code?.length === 7) {
      this.issuedByList = await this.dadataModule.actions.getFmsUnits(code).catch(mock)
    }
  }

  validateForm() {
    this.$v.form.$touch()
    if (!this.$v.form.$anyError) this.isShowCaptcha = true
  }

  proceedToStepTwo(captcha: CaptchaCheck) {
    this.captchaAnswers = captcha
    this.step = 2
  }

  async sendForm() {
    try {
      await this.claimModule.actions.sendForm({
        form: this.form.toSave(this.nspkProgramResident),
        captcha: this.captchaAnswers,
      })
      this.openAlert({ type: 'success', message: 'Заявление успешно отправлено', duration: 4000 })
      this.claimModule.mutations.setForm(new ClaimForm(this.securityModule.state.user))
      this.form = new ClaimForm(this.securityModule.state.user)
      this.$v.form.$reset()
      this.isExitAccept = true
      await wait(800)
      await this.$router.push({ name: 'main' })
    } catch (error) {
      mock(error)
    }
  }
}

export default ConnectCardFormView
